import React, { Component } from "react";
import {NavLink} from 'react-router-dom';

export default class NavbarEntidade extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-sm">
                <div className="bs-component">
                    <ul className="navbar-nav nav-pills">
                        <li className="cabecalho-flex">
                            <NavLink
                                className='nav-link active'
                                to="/Home/Entidade/NovaEntidade">
                                <label> Dados Entidade </label>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}